<div class="tag-container">
  <div class="tag-search">
    <span *ngFor="let tag of tagModel.tags" class='tag' id="tag{{tag}}"><span class='closeTag' (click)="deleteTag(tag)">&times;</span>{{tag}} </span>
    <input #tagTyper class="typer" type="text" (keypress)="keyPress($event)" [ngModel]="tag" (ngModelChange)="autoSuggestChange($event)" (focus)="addCloseListener()" (keydown)="getArrowKeys($event)" placeholder="{{placeholder}}" autocomplete="off" />
  </div>


  <div #autoSuggest class="auto-suggset -hidden">
    <div class="label" *ngIf="filteredTag.length > 0">Suggestion de tags existants: </div>
    <div #tagAutoSuggest class="tag" *ngFor="let tag of filteredTag | slice:0:20;" (click)="addSuggestTag(tag)" (mouseenter)="clearArrowSelect()">{{tag}}</div>
    <div *ngIf="!isSearchMode" class="label">Appuyer sur <b>Enter</b> pour créer un tag</div>
  </div>
</div>

